import React from 'react'
import { buildPropTypes, pt } from 'common-data/proptypehelpers'
import _ from 'common-tools/LodashHelper'
import { Grid } from './Grid'
import { GridCell } from './GridCell'
import { Button } from './Button'
import clsx from 'clsx'
import { componentGetCompareProps } from 'common-tools/index'
import { FAIcon } from './FAIcon'
import styles from './Wizard2Box.less'

export const Wizard2BoxSteps = {
  Done: 'done',
  Cancel: 'cancel'
}

export class Wizard2BoxItem extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    children: pt.any,
    stepId: pt.string.isRequired,
    nextStepId: pt.string.isRequired,
    previousStepId: pt.string,
    icon: pt.string.isRequired
  })

  static defaultProps = {
    icon: 'building'
  }

  render () {
    const { children } = this.props
    return children
  }
}

export class Wizard2Box extends React.Component {
  constructor (props) {
    super(props)
    const { activeStepId } = props

    this.state = {
      activeStep: activeStepId,
      visitedSteps: [],
      changingSteps: false
    }
  }

  static propTypes = buildPropTypes([

  ], {
    children: pt.oneOfType([pt.arrayOf(pt.element), pt.element]),
    stepMap: pt.arrayOf(pt.shape({
      previousId: pt.string,
      currentId: pt.string,
      nextId: pt.string
    })),
    activeStepId: pt.string
  })

  static defaultProps = {
    stepMap: []
  }

  componentDidUpdate (prevProps, prevState) {
    let activeStepId = componentGetCompareProps('activeStepId', this.props, prevProps, '')

    if (activeStepId.HasChanged) {
      const { visitedSteps } = this.state
      this.setState({
        visitedSteps: _.concat(visitedSteps, [activeStepId.Current])
      }, () => {
        this.toggle(activeStepId.Current, true)
      })
    }
  }

  async toggle (stepId, resetActiveStep = false) {
    const { beforeStepAction, afterStepAction, stepMap } = this.props
    const { visitedSteps, activeStep } = this.state

    this.setState({
      changingSteps: true
    })

    if (activeStep !== stepId) {
      let stepIdList = _.map(stepMap, (sm) => { return sm.currentId })
      stepIdList.unshift(Wizard2BoxSteps.Cancel)
      stepIdList.push(Wizard2BoxSteps.Done)

      let currentStepPos = _.indexOf(stepIdList, activeStep)
      let nextStepIdPos = _.indexOf(stepIdList, stepId)

      let toggleDirection = 'none'

      if (currentStepPos < nextStepIdPos) {
        toggleDirection = 'forward'
      } else if (currentStepPos > nextStepIdPos) {
        toggleDirection = 'backward'
      }

      if (_.isFunction(beforeStepAction)) {
        if (await beforeStepAction(stepId, resetActiveStep ? undefined : activeStep, toggleDirection)) {
          this.setState({
            changingSteps: false
          })
          return // abort step
        }
      }
      if (stepId !== Wizard2BoxSteps.Cancel) {
        this.setState({
          activeStep: stepId,
          visitedSteps: _.concat(visitedSteps, stepId)
        }, async () => {
          if (_.isFunction(afterStepAction)) {
            await afterStepAction(stepId, resetActiveStep ? undefined : activeStep, toggleDirection)
          }
        })
      }
    }

    this.setState({
      changingSteps: false
    })
  }

  getItems (stepMap, children, loading) {
    const ret = {
      navs: [],
      steps: []
    }
    const { testId } = this.props
    const { activeStep, visitedSteps } = this.state

    for (let currentStepMap of stepMap) {
      let currentId = currentStepMap.currentId
      let matchChild = _.find(children, (i) => { return i.props.stepId === currentId }) || { props: {
        icon: 'question',
        children: undefined
      } }

      ret.navs.push(
        <li data-tid={`${testId}-${currentId}-nav`} key={currentId} className={clsx('tabs-title', activeStep === currentId ? 'active' : _.indexOf(visitedSteps, currentId) > -1 ? 'completed' : '')}>
          <a href="#" onClick={loading === true ? undefined : _.indexOf(visitedSteps, currentId) > -1 ? () => { this.toggle(currentId) } : null} aria-selected={activeStep === currentId ? 'true' : undefined}>
            <FAIcon size='35px' name={matchChild.props.icon || 'question'} />
          </a>
        </li>
      )
      ret.steps.push(
        <div data-tid={`${testId}-${currentId}-tab`} key={currentId} className={clsx('tabs-panel', activeStep === currentId && 'is-active')}>
          {activeStep === currentId
            ? _.isFunction(matchChild.props.children)
              ? matchChild.props.children({
                firstVisit: _.indexOf(visitedSteps, currentStepMap.nextId) === -1,
                nextId: currentStepMap.nextId,
                previousId: currentStepMap.previousId,
                visitedSteps: visitedSteps || []
              })
              : matchChild.props.children
            : null
          }
        </div>
      )
    }

    ret.navs.unshift(
      <li data-tid={`${testId}-${Wizard2BoxSteps.Cancel}-nav`} key={Wizard2BoxSteps.Cancel} className={clsx('tabs-title')}>
        <a href="#" onClick={() => { this.toggle(Wizard2BoxSteps.Cancel) }}>
          <FAIcon size='35px' name='times' />
        </a>
      </li>
    )

    return ret
  }

  renderStepAction (action, loading) {
    const { hideNextStepButton, stepMap, testId } = this.props
    const { activeStep } = this.state

    const matchStep = _.find(stepMap, { currentId: activeStep })

    if (!matchStep) {
      return null
    }

    switch (action) {
      case 'next':

        let nextId = matchStep.nextId
        let nextIdClick = loading === true ? undefined : () => { this.toggle(nextId) }

        if (nextId === Wizard2BoxSteps.Done) {
          return <Button data-tid={`${testId}-wizardNext`} onClick={nextIdClick}>
            {loading === true
              ? <FAIcon size='35px' name='spinner' spin />
              : <FAIcon size='35px' name='check' />
            }
          </Button>
        } else {
          if (nextId) {
            if (hideNextStepButton === true) {
              return <Button outline data-tid={`${testId}-wizardNext`}>
                <FAIcon size='35px' name='times' toolTip='Thou shalt not pass!' />
              </Button>
            } else {
              return <Button data-tid={`${testId}-wizardNext`} onClick={nextIdClick}>
                <FAIcon size='35px' name='chevron-right' />
              </Button>
            }
          }
          break
        }
      case 'previous':

        let previousId = matchStep.previousId
        let previousIdClick = loading === true ? undefined : () => { this.toggle(previousId) }

        if (previousId) {
          return <Button outline data-tid={`${testId}-wizardPrev`} onClick={previousIdClick}>
            <FAIcon name='chevron-left' size='35px' />
          </Button>
        }
        break
      default:
        return null
    }
  }

  render () {
    const { children, stepMap, loading = false } = this.props
    const { changingSteps } = this.state

    const processing = loading || changingSteps
    const items = this.getItems(stepMap, children, processing)

    return (
      <Grid vertical frame className={styles.wizard}>
        <GridCell shrink>
          <ul className='tabs'>
            {items.navs}
          </ul>
        </GridCell>
        <GridCell auto className='tabs-content'>
          <Grid vertical frame >
            <GridCell blockY>
              {items.steps}
            </GridCell>
          </Grid>
        </GridCell>
        <GridCell className='text-center' shrink>
          {this.renderStepAction('previous', processing)}
          {this.renderStepAction('next', processing)}
        </GridCell>
      </Grid>
    )
  }
}
